import { Injectable } from "@angular/core";
import { Http, Response } from "@angular/http";
import { Observable } from "rxjs";
import {
  ConsigneeRequest,
  ConsigneeResponse,
  CustomerRequest,
  CustomerResponse,
  AdminRequest,
  AdminResponse,
  SchoolRequest,
  SchoolResponse,
  UserRequest,
  UserResponse,
} from "@builtbybros/al-model";

import { AuthService } from "../../auth/auth.service";
import { environment } from "../../../environments/environment";

@Injectable()
export class UserService {
  userUrl = "/User";
  adminUrl = "/Admin";
  customerUrl = "/Customer";
  consigneeUrl = "/Consignee";
  schoolUrl = "/School";

  constructor(
    private http: Http,
    private authService: AuthService,
  ) { }

  updateUser( id: number, userRequest: UserRequest.Update): Observable<UserResponse.User> {
    const options = this.authService.addAuthToken();

    return this.http.patch(environment.alApiUrl + this.userUrl + '/' + id, userRequest, options)
      .map((res) => {
        const json = res.json();
        const userResponse = new UserResponse.User();
        return userResponse.parse(json);
      });
  }

  createAdmin(adminRequest: AdminRequest.Create): Observable<AdminResponse.Admin> {
    const options = this.authService.addAuthToken();
    return this.http.post(environment.alApiUrl + this.adminUrl, adminRequest, options)
      .map((res) => {
        const json = res.json();
        const adminResponse = new AdminResponse.Admin();
        return adminResponse.parse(json);
      });
  }

  createConsignee(consigneeRequest: ConsigneeRequest.Create): Observable<ConsigneeResponse.Consignee> {
    const options = this.authService.addAuthToken();
    return this.http.post(environment.alApiUrl + this.consigneeUrl, consigneeRequest, options)
      .map((res) => {
        const json = res.json();
        const consigneeResponse = new ConsigneeResponse.Consignee();
        return consigneeResponse.parse(json);
      });
  }

  createCustomer(customerRequest: CustomerRequest.Create): Observable<CustomerResponse.Customer> {
    const options = this.authService.addAuthToken();
    return this.http.post(environment.alApiUrl + this.customerUrl, customerRequest, options)
      .map((res) => {
        const json = res.json();
        const customerResponse = new CustomerResponse.Customer();
        return customerResponse.parse(json);
      });
  }

  createSchool(schoolRequest: SchoolRequest.Create): Observable<SchoolResponse.School> {
    const options = this.authService.addAuthToken();
    return this.http.post(environment.alApiUrl + this.schoolUrl, schoolRequest, options)
      .map((res) => {
        const json = res.json();
        const schoolResponse = new SchoolResponse.School();
        return schoolResponse.parse(json);
      });
  }

  updateAdmin(id: number, adminRequest: AdminRequest.Update): Observable<AdminResponse.Admin> {
    const options = this.authService.addAuthToken();

    return this.http.patch(environment.alApiUrl + this.adminUrl + '/', adminRequest, options)
      .map((res) => {
        const json = res.json();
        const adminResponse = new AdminResponse.Admin();
        return adminResponse.parse(json);
      });
  }

  updateCustomer(id: number, customerRequest: CustomerRequest.Update): Observable<CustomerResponse.Customer> {
    const options = this.authService.addAuthToken();

    return this.http.patch(environment.alApiUrl + this.customerUrl + '/', customerRequest, options)
      .map((res) => {
        const json = res.json();
        const customerResponse = new CustomerResponse.Customer();
        return customerResponse.parse(json);
      });
  }

  updateConsignee(id: number, consigneeRequest: ConsigneeRequest.Update): Observable<ConsigneeResponse.Consignee> {
    const options = this.authService.addAuthToken();

    return this.http.patch(environment.alApiUrl + this.consigneeUrl + '/', consigneeRequest, options)
      .map((res) => {
        const json = res.json();
        const consigneeResponse = new ConsigneeResponse.Consignee();
        return consigneeResponse.parse(json);
      });
  }

  updateSchool(id: number, schoolRequest: SchoolRequest.Update): Observable<SchoolResponse.School> {
    const options = this.authService.addAuthToken();

    return this.http.patch(environment.alApiUrl + this.schoolUrl + '/', schoolRequest, options)
      .map((res) => {
        const json = res.json();
        const schoolResponse = new SchoolResponse.School();
        return schoolResponse.parse(json);
      });
  }

  getUser(id: number): Observable<UserResponse.User> {
    const options = this.authService.addAuthToken();
    return this.http
      .get(environment.alApiUrl + this.userUrl + '/' + id, options)
      .map((res: Response) => {
        const json = res.json();
        return json;
      });
  }

  getAllUsers(): Observable<UserResponse.All> {
    const options = this.authService.addAuthToken();
    return this.http
      .get(`${environment.alApiUrl}${this.userUrl}/All`, options)
      .map((res: Response) => {
        const json = res.json();
        return json;
      });
  }

  // TODO: Catch error.
  deleteUser(id: number): Observable<number> {
    const options = this.authService.addAuthToken();
    return this.http
      .delete(`${environment.alApiUrl}${this.userUrl}/${id}`, options)
      .map((res: Response) => {
        const json = res.json();
        return json;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/user/shared/user.service.ts